export default __webpack_public_path__ + "static/media/sign-in-with-google.ff9abf07.svg";